module.exports = __webpack_public_path__ + "static/media/wm.7a813b54d79bac9f941a1221f246406e.svg";